var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "download",
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-21312{fill:#DFF0E1}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_639",
    width: 33,
    height: 22,
    fill: "#A9DBAF",
    rx: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-2",
    transform: "translate(9.778 3.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    transform: "translate(3.137)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    d: "M135.128 6.537a.447.447 0 0 0-.408-.263h-1.793V.448a.448.448 0 0 0-.448-.448h-1.793a.448.448 0 0 0-.448.448v5.826h-1.793a.448.448 0 0 0-.337.743l3.137 3.585a.447.447 0 0 0 .674 0l3.137-3.585a.447.447 0 0 0 .072-.48z",
    className: "cls-21312",
    transform: "translate(-127.998)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    transform: "translate(0 9.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    d: "M27.652 352v2.689h-9.859V352H16v3.585a.9.9 0 0 0 .9.9h11.648a.9.9 0 0 0 .9-.9V352z",
    className: "cls-21312",
    transform: "translate(-16 -352)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c9612387e43671f74d91e4c2fd9ffdca.svg";
export { ForwardRef as ReactComponent };